import React from 'react';
import { HumanMessageProps } from './types';

const formatTime = (timestamp: string): string => {
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const HumanMessage: React.FC<HumanMessageProps> = ({ content, timestamp }) => {
  return (
    <div className="agentic-message human-message">
      <div className="message-bubble human-bubble">
        <div className="message-content">{content}</div>
      </div>
      {timestamp && (
        <div className="message-timestamp human-timestamp">
          {formatTime(timestamp)}
        </div>
      )}
    </div>
  );
};

export default HumanMessage;
